module.exports = __webpack_public_path__ + "static/img/B80-VEL-A.080957c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/B80-VEL-A.jpg
// module id = xnet
// module chunks = 0